import React, {Dispatch, FC, useCallback, useEffect, useState} from 'react';
import {Alert, Button, Modal} from "react-bootstrap";
import {FaExpandAlt} from "react-icons/fa";
import ObjectService from "../../http/ObjectService";
import Loading from "../Loading";

interface PropsModal {
    visible: boolean;
    setVisible: Dispatch<boolean>;
    objectId: string | number | null;
    refreshTable: () => void;
}

const ObjectModalDelete: FC<PropsModal> = (props) => {
    const [object, setObject] = useState<any | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);
    const [warning, setWarning] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [needsRefresh, setNeedsRefresh] = useState<boolean>(false);
    const [fullscreen, setFullscreen] = useState<boolean>(false);

    const fetchObject = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const { data } = await ObjectService.query({
                includes: ["object_ankets"],
                options: {where: { id: props.objectId } }
            });

            if (data && data.length > 0) {
                const objectData = data[0];

                if (objectData.action === "DELETE") {
                    setError('Категория уже удалена');
                    setNeedsRefresh(true);
                } else if(objectData.object_ankets && objectData.object_ankets.length > 0) {
                    const arrObjectsAnkets = [];
                    for (const object_anketa of objectData.object_ankets) {
                        if(object_anketa.action === "DELETE") continue;
                        arrObjectsAnkets.push(`<b>${object_anketa.lastname} ${object_anketa.firstname} ${object_anketa.middlename}</b>`);
                    }
                    if(arrObjectsAnkets.length > 0) {
                        setError(`<div class="h6 mb-1">Нельзя удалить!</div>Объект привязан к анкетам объекта:<br> ${arrObjectsAnkets.join("<br>")}`);
                        setNeedsRefresh(true);
                    }
                }

                setObject(objectData);
            } else {
                setNeedsRefresh(true);
                setError("Объект не найден");
            }
        } catch (err: any) {
            setError(err.response?.data?.message || err.message);
        } finally {
            setLoading(false);
        }
    }, [props.objectId]);

    useEffect(() => {
        if (props.visible) {
            void fetchObject();
        }
    }, [props.visible, fetchObject]);

    const handleObjectDelete = async () => {
        setLoading(true);
        try {
            const { data } = await ObjectService.delete({
                values: { action: "DELETE" },
                options: { where: { id: object.id } }
            });

            if (data) {
                setSuccess("Объект удалён");
                setWarning(null);
                setNeedsRefresh(true);
            } else {
                setWarning("Не удалось удалить объект");
            }
        } catch (err: any) {
            setError(err.response?.data?.message || err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleHideModal = () => {
        if (needsRefresh) props.refreshTable();
        props.setVisible(false);
    };

    return (
        <Modal show={props.visible} size={"lg"} fullscreen={fullscreen ? true : "md-down"} scrollable={true}
               onHide={handleHideModal}>
            <div className="modal-header">
                <h5 className="mb-0">Удаление категории</h5>
                <div className={"d-flex gap-3"}>
                    <button type="button" className="btn-link" onClick={() => setFullscreen(!fullscreen)}>
                        <FaExpandAlt/>
                    </button>
                    <button type="button" className="btn-close" onClick={handleHideModal}></button>
                </div>
            </div>
            {loading
                ?
                <div style={{height: "200px"}}><Loading/></div>
                :
                <>
                    <Modal.Body>
                        {object
                            ?
                            <>
                                {success && (
                                    <Alert variant={"success"}>
                                        <div><b>{object.name}</b></div>
                                        {success}
                                    </Alert>
                                )}
                                {error && (
                                    <Alert variant={"danger"}>
                                        <div dangerouslySetInnerHTML={{ __html: error }} />
                                    </Alert>
                                )}
                                {!needsRefresh && (
                                    <Alert variant={"warning"}>
                                        <div><b>{object.name}</b></div>
                                        Объект будет удалён
                                    </Alert>
                                )}
                                {warning && <Alert variant={"warning"}>{warning}</Alert>}
                            </>
                            :
                            <Alert variant={"warning"}>Объект не найден</Alert>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {object && !needsRefresh && (
                            <Button variant="danger" type="button" onClick={handleObjectDelete}>Удалить</Button>)}
                        <Button variant="secondary" onClick={handleHideModal}>
                            {needsRefresh ? "Закрыть" : "Отмена"}
                        </Button>
                    </Modal.Footer>
                </>
            }
        </Modal>
    );
};

export default ObjectModalDelete;